var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalkonAisvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_161755",
    "data-name": "Group 161755",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.931,
    height: 24.931,
    viewBox: "0 0 24.931 24.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports_Outline_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    width: 24.931,
    height: 24.931,
    fill: "#ffe4e4",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_161503",
    "data-name": "Group 161503",
    transform: "translate(1.039 4.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M9.164,6.179a13.661,13.661,0,0,1-7.154,7.149.556.556,0,0,0,0,1.022,13.63,13.63,0,0,1,7.13,7.093.586.586,0,0,0,1.076,0,13.655,13.655,0,0,1,7.129-7.093.555.555,0,0,0,0-1.021,13.663,13.663,0,0,1-7.152-7.15.56.56,0,0,0-1.03,0Z",
    transform: "translate(-1.672 -5.638)",
    fill: "none",
    stroke: "#b781ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M131.523,111.357a5,5,0,0,1-2.267,2.267.332.332,0,0,0,0,.6,4.988,4.988,0,0,1,2.267,2.267.331.331,0,0,0,.6,0,5,5,0,0,1,2.268-2.268.332.332,0,0,0,0-.6,5,5,0,0,1-2.267-2.268.332.332,0,0,0-.6,0Z",
    transform: "translate(-114.951 -99.293)",
    fill: "none",
    stroke: "#b781ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M145.073,4.309A6.861,6.861,0,0,1,142.2,7.187a.552.552,0,0,0,0,.974,6.837,6.837,0,0,1,2.876,2.876.553.553,0,0,0,.975,0,6.856,6.856,0,0,1,2.876-2.876.553.553,0,0,0,0-.974,6.874,6.874,0,0,1-2.877-2.877.553.553,0,0,0-.974,0Z",
    transform: "translate(-126.362 -4.018)",
    fill: "none",
    stroke: "#b781ff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonAisvg);
export default __webpack_public_path__ + "static/media/FalkonAISVG.5cb90ab8146162b3e52aed023f7b5a97.svg";
export { ForwardRef as ReactComponent };